var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYesNo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.6 139.854 16 16",
    enableBackground: "new 78.6 139.854 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M82.666,145.759l-1.546-1.546l-0.707,0.707l2.253,2.253l4.204-4.204l-0.707-0.707L82.666,145.759z  M88.02,152.819l1.572-1.571l1.572,1.571l0.707-0.707l-1.572-1.571l1.572-1.572l-0.707-0.707l-1.572,1.572l-1.572-1.572 l-0.707,0.707l1.572,1.572l-1.572,1.571L88.02,152.819z M88.6,145.854v-6h-10v10h6v6h10v-10H88.6z M84.6,148.854h-5v-8h8v5h-3 V148.854z M93.6,154.854h-8v-8h8V154.854z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYesNo01);
export default __webpack_public_path__ + "static/media/icon_yes_no-01.c8508aac80e2c7363c2223d935ad80fa.svg";
export { ForwardRef as ReactComponent };